import React from "react";
import ChooseUsCard from "./ChooseUsCard";
import SectionHeading from "../common/SectionHeading";

const WhyChooseUs = () => {
    const features = [
        {
            title: "24/7 Operational Excellence",
            image_path: "/assets/images/24-hours-support.png",
            description: "Our logistics network runs seamlessly 24 hours a day to ensure timely, dependable delivery—whenever our clients need us."
        },
        {
            title: "Precision & Speed",
            image_path: "/assets/images/deadline.png",
            description: "We deliver with urgency and accuracy, maintaining high standards across every shipment to ensure reliability and performance."
        },
        {
            title: "Client-Centric Service",
            image_path: "/assets/images/customer-centricity.png",
            description: "We prioritize client satisfaction by offering responsive support, tailored solutions, and a consistently smooth delivery experience."
        }
    ];

    return (
        <section className="md:py-20 py-10 px-5 bg-white overflow-hidden">
            <div className="max-w-7xl mx-auto px-4">
                
                <div className="mb-12">
                    <SectionHeading 
                        subtitle="Our Strengths" 
                        title="Why Choose Us?" 
                    />
                </div>

                {/* Pure Tailwind Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {features.map((item, index) => (
                        <ChooseUsCard 
                            key={index}
                            title={item.title}
                            image_path={item.image_path}
                            description={item.description}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;